import React from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"
const getUserData = JSON.parse(localStorage.getItem("authUser")) 
const WelcomeComp = ({AllOrders,PendingOrders}) => {
  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome Back !</h5>
                <p>Dashboard</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              {/* <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={avatar1}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div> */}
              <h5 className="font-size-15 text-truncate mt-4">{getUserData && getUserData.userData.payload.username}</h5>
              <p className="text-muted mb-0 text-truncate">Admin</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">{AllOrders && AllOrders}</h5>
                    <p className="text-muted mb-0">Orders</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">{PendingOrders && PendingOrders}</h5>
                    <p className="text-muted mb-0">Pending Orders</p>
                  </Col>
                </Row>
                {/* <div className="mt-4">
                  <Link
                    to=""
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div> */}
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
